import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: indent,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  avatar: {
    height: 40,
    width: 40,
    borderRadius: 20,
  },
  informationContainer: {
    flex: 1,
    marginLeft: indent * 0.8,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  name: {
    height: 14,
    width: '40%',
    marginBottom: 0.3 * indent,
  },
  rank: {
    height: 14,
    width: '50%',
    marginBottom: 0.3 * indent,
  },
});
